import { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../../components/common/Input';
import { validateEmail, validateRequired } from '../../utils/validators';
import api from '../../services/api';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    if (!validateRequired(email)) {
      setFieldError('Email is required');
      return false;
    }
    if (!validateEmail(email)) {
      setFieldError('Please enter a valid email');
      return false;
    }
    setFieldError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setError('');

    try {
      await api.post('/auth/password-reset/', { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      if (err.response?.status === 429) {
        setError('Too many requests. Please wait a minute and try again.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-pw">
      <div className="forgot-pw__panel">
        <div className="forgot-pw__container">

          <div className="forgot-pw__header">
            <h2 className="forgot-pw__title">Reset Password</h2>
            <p className="forgot-pw__subtitle">Deep Roots Milling &mdash; Wholesale Portal</p>
          </div>

          {submitted ? (
            <div className="forgot-pw__success">
              <div className="forgot-pw__success-icon">&#10003;</div>
              <h3 className="forgot-pw__success-heading">Check Your Email</h3>
              <p className="forgot-pw__success-text">
                If an account exists for <strong>{email}</strong>, we've sent a
                password reset link. It may take a minute to arrive.
              </p>
              <p className="forgot-pw__success-hint">
                Don't see it? Check your spam folder.
              </p>
              <Link to="/login" className="forgot-pw__back-link">
                &larr; Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <p className="forgot-pw__instructions">
                Enter the email address on your account and we'll send you a link
                to reset your password.
              </p>

              {error && (
                <div className="forgot-pw__error" role="alert">{error}</div>
              )}

              <form className="forgot-pw__form auth-form" onSubmit={handleSubmit} noValidate>
                <Input
                  type="email"
                  name="email"
                  label="Email Address"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (fieldError) setFieldError('');
                    if (error) setError('');
                  }}
                  error={fieldError}
                  placeholder="you@company.com"
                  autoComplete="email"
                  required
                  autoFocus
                />

                <button
                  type="submit"
                  className="forgot-pw__submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="forgot-pw__footer">
                <p>
                  <Link to="/login" className="forgot-pw__link">
                    &larr; Back to Sign In
                  </Link>
                </p>
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
